/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Review_ChecklistInputs */

const vi_einvoice_review_checklist = /** @type {(inputs: Einvoice_Review_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người mua / mã số thuế · Hàng hóa / số lượng · Tiền hàng / thuế / tổng tiền`)
};

/**

* @param {Einvoice_Review_ChecklistInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_review_checklist = /** @type {((inputs?: Einvoice_Review_ChecklistInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Review_ChecklistInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_review_checklist(inputs)
});